/**
 * Removes any trailing slashes from the given path.
 */
export function removeTrailingSlash(path: string): string {
  // The regex /\/+$/ matches one or more slashes at the end of the string.
  return path.replace(/\/+$/, "");
}
